import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";

export default function StudentStudy() {
  const nav = useNavigate();

  const [subjects, setSubjects] = useState([]);
  const [activeSubject, setActiveSubject] = useState(null);
  const [activeTab, setActiveTab] = useState("study"); 
// study | practice | case-study
  const [studyContents, setStudyContents] = useState([]);
  const [practiceSets, setPracticeSets] = useState([]);
  const [attemptsMap, setAttemptsMap] = useState({});

  const [caseStudySets, setCaseStudySets] = useState([]);
  const [caseStudyAttemptsMap, setCaseStudyAttemptsMap] = useState({});

  const [loading, setLoading] = useState(false);

  /* ==================================================
     LOAD SUBSCRIBED SUBJECTS
  ================================================== */
  useEffect(() => {
    api
      .get("/study/my-subjects")
      .then((res) => {
        setSubjects(res.data.subjects || []);
        if (res.data.subjects?.length) {
          setActiveSubject(res.data.subjects[0].id);
        }
      })
      .catch(() => {
        alert("❌ Subscription expired or invalid");
      });
  }, []);

  /* ==================================================
     LOAD STUDY CONTENT OR PRACTICE SETS
  ================================================== */
  /* ================= LOAD DATA BASED ON TAB ================= */
  useEffect(() => {
    if (!activeSubject) return;

    setLoading(true);

    const request =
      activeTab === "study"
        ? api.get(`/study/subject/${activeSubject}`)
        : activeTab === "practice"
        ? api.get("/study/practice-sets")
        : api.get("/student/case-study-practice/list");

    request
      .then(res => {
        if (activeTab === "study") {
          setStudyContents(res.data.contents || []);
        }

        else if (activeTab === "practice") {
          const filtered = (res.data || []).filter(
            s => s.subject_id === activeSubject
          );

          setPracticeSets(filtered);
          loadAttempts(filtered.map(s => s.id));
        }

        else {
          const filtered = (res.data || []).filter(
            s => s.subject_id === activeSubject
          );

          setCaseStudySets(filtered);
          loadCaseStudyAttempts(filtered.map(s => s.id));
        }
      })
      .finally(() => setLoading(false));
  }, [activeSubject, activeTab]);

  /* ==================================================
     LOAD PRACTICE ATTEMPTS
  ================================================== */
  const loadAttempts = async (setIds) => {
    try {
      const res = await api.get("/study/practice-history");
      const map = {};

      res.data.forEach(a => {
        if (setIds.includes(a.practice_set_id)) {
          if (!map[a.practice_set_id]) map[a.practice_set_id] = [];
          map[a.practice_set_id].push(a);
        }
      });

      setAttemptsMap(map);
    } catch {
      console.error("Failed loading practice history");
    }
  };

  /* Start Case study practice */
  const loadCaseStudyAttempts = async (setIds) => {
    try {
      const res = await api.get("/student/case-study-practice/attempts");
      const map = {};

      res.data.forEach(a => {
        if (setIds.includes(a.practice_set_id)) {
          if (!map[a.practice_set_id]) map[a.practice_set_id] = [];
          map[a.practice_set_id].push(a);
        }
      });

      setCaseStudyAttemptsMap(map);
    } catch {
      console.error("Failed loading case study attempts");
    }
  };

  /* ==================================================
     START PRACTICE
  ================================================== */
    const startPractice = async (setId) => {
      try {
        nav(`/student/practice/take/${setId}`);
      } catch (err) {
        console.error(err);
        alert("❌ Unable to start practice");
      }
    };

    const viewPracticeResult = (attemptId) => {
      nav("/student/practice/result", { state: { attemptId } });
    };

  /* ================= START CASE STUDY ================= */
  const startCaseStudy = async (id) => {
    const res = await api.get(`/student/case-study-practice/${id}/start`);
    sessionStorage.setItem("caseStudyPractice", JSON.stringify(res.data));
    nav("/student/case-study/take");
  };

  /* ================= DATE FORMATTER ================= */
  const formatDateTime = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleString();
  };

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={contentWrapper}>
          {/* HEADER */}
          <div style={headerRow}>
            <img src="/logo.png" alt="EduAt10" style={logoStyle} />

            <button
              onClick={() => nav("/user/dashboard")}
              style={backBtnStyle}
            >
              ← Back to Dashboard
            </button>
          </div>

          <h2>📚 Study Area Subject wise Topics</h2>

          {/* SUBJECTS */}
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {subjects.map((s) => (
              <button
                key={s.id}
                onClick={() => setActiveSubject(s.id)}
                style={{
                  padding: "8px 14px",
                  background:
                    activeSubject === s.id ? "#2563eb" : "#e5e7eb",
                  color: activeSubject === s.id ? "#fff" : "#000",
                  border: "none",
                  borderRadius: 6,
                  cursor: "pointer",
                }}
              >
                {s.name}
              </button>
            ))}
          </div>

          {activeSubject && (
            <>
              {/* TABS */}
              <div style={{ marginTop: 20 }}>
                <button
                  onClick={() => setActiveTab("study")}
                  style={tabBtn(activeTab === "study")}
                >
                  📘 Study
                </button>
                <button
                  onClick={() => setActiveTab("practice")}
                  style={{ ...tabBtn(activeTab === "practice"), marginLeft: 10 }}
                >
                  🧠 Practice
                </button>
                <button
                  onClick={() => setActiveTab("case-study")}
                  style={{ ...tabBtn(activeTab === "case-study"), marginLeft: 10 }}
                >
                  📘 Scenario-based Questions/ assesment..!
                </button>
              </div>

              {loading && <p>⏳ Loading...</p>}

              {/* STUDY CONTENT */}
              {activeTab === "study" && !loading && (
                <table border="1" width="100%" style={tableStyle}>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Title</th>
                      <th>Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {studyContents.map((c, i) => (
                      <tr key={c.id}>
                        <td>{i + 1}</td>
                        <td>{c.title}</td>
                        <td>{c.file_type}</td>
                        <td>
                          <a href={`/student/content/${c.id}`}>📖 Read</a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {/* PRACTICE */}
              {activeTab === "practice" && !loading && (
                <table border="1" width="100%" style={tableStyle}>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Questions</th>
                      <th>Duration</th>
                      <th>Action</th>
                      <th>Result</th>
                    </tr>
                  </thead>
                  <tbody>
                    {practiceSets.map(p => (
                      <tr key={p.id}>
                        <td>{p.name}</td>
                        <td>{p.num_questions}</td>
                        <td>{p.duration_minutes} min</td>
                        <td>
                          <button onClick={() => startPractice(p.id)}>
                            ▶ Start
                          </button>
                        </td>

                        <td>
                          {attemptsMap[p.id]?.length ? (
                            attemptsMap[p.id].map((a, i) => (
                              <div key={a.attempt_id} style={{ marginBottom: 8 }}>
                                <strong>
                                  Attempt {i + 1}
                                </strong>
                                <br />
                                Score: {a.score}/{a.total_questions} (
                                {a.percentage}%)
                                <br />
                                📅 {formatDateTime(a.submitted_at)}
                                <br />
                                <button
                                  onClick={() =>
                                    nav("/student/practice/result", {
                                      state: { attemptId: a.attempt_id }
                                    })
                                  }
                                >
                                  View
                                </button>
                              </div>
                            ))
                          ) : (
                            <span style={{ color: "#888" }}>No attempts</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              {/* CASE STUDY TAB */}
              {activeTab === "case-study" && !loading && (
                <table border="1" width="100%" style={tableStyle}>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Case Studies</th>
                      <th>Duration</th>
                      <th>Action</th>
                      <th>Result</th>
                    </tr>
                  </thead>
                  <tbody>
                    {caseStudySets.map(cs => (
                      <tr key={cs.id}>
                        <td>{cs.title}</td>
                        <td>{cs.case_study_count}</td>
                        <td>{cs.duration_minutes} min</td>
                        <td>
                          <button onClick={() => startCaseStudy(cs.id)}>
                            ▶ Start
                          </button>
                        </td>

                        <td>
                          {caseStudyAttemptsMap[cs.id]?.length ? (
                            caseStudyAttemptsMap[cs.id].map((a, i) => (
                              <div key={a.attempt_id} style={{ marginBottom: 8 }}>
                                <strong>
                                  Attempt {i + 1}
                                </strong>
                                <br />
                                Score: {a.score}/{a.total_questions} (
                                {a.percentage}%)
                                <br />
                                📅 {formatDateTime(a.submitted_at)}
                                <br />
                                <button
                                  onClick={() =>
                                    nav("/student/case-study/result", {
                                      state: { attemptId: a.attempt_id }
                                    })
                                  }
                                >
                                  View
                                </button>
                              </div>
                            ))
                          ) : (
                            <span style={{ color: "#888" }}>
                              No attempts
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ================= BACKGROUND ================= */
const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};

const contentWrapper = {
  background: "rgba(255,255,255,0.9)",
  borderRadius: 16,
  padding: 30,
};

/* ================= STYLES ================= */
const logoStyle = {
  width: 120,
};

const headerRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 12,
  marginBottom: 20,
};

const backBtnStyle = {
  padding: "10px 16px",
  background: "#02884e",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

const tableStyle = {
  marginTop: 20,
  background: "#fff",
};

const tabBtn = (active) => ({
  padding: "8px 14px",
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
  background: active ? "#02884e" : "#ffc007",
  color: active ? "#fff" : "#000",
  marginBottom: 15,
});
